import { formatLocalDateTime } from './dateTime';
export { focusFirstFormError } from './focusFirstFormError';
export {
  formatLocalDate,
  formatLocalDateTime,
  toLocalOffsetISOString,
} from './dateTime';

/* -------------------------------------------------- storage -------------------------------------------------- */

export const lStorage = {
  get<T = any>(key: string): T | null {
    const value = localStorage.getItem(key);
    if (value === null) return null;
    try {
      return JSON.parse(value) as T;
    } catch {
      return value as unknown as T;
    }
  },
  set(key: string, value: any) {
    localStorage.setItem(
      key,
      typeof value === 'string' ? value : JSON.stringify(value),
    );
  },
  remove(key: string) {
    localStorage.removeItem(key);
  },
};

// getToken / setToken / clearToken 已删除：会话是服务端下发的 httpOnly Cookie
// （MUOU_ADMIN），前端读不到也写不了，没有任何凭证需要存取。

/* -------------------------------------------------- 通用 -------------------------------------------------- */

export const isExternal = (path?: string) =>
  !!path && /^(https?:|mailto:|tel:)/.test(path);

export const formatDateTime = (
  date?: string | number | Date,
  format = 'YYYY-MM-DD HH:mm:ss',
) => formatLocalDateTime(date, format);

/* -------------------------------------------------- 输入清洗 -------------------------------------------------- */

/**
 * 首尾空白字符
 *
 * `\s` 已覆盖普通空格 / Tab / 换行 / NBSP(U+00A0) / 全角空格(U+3000) / BOM(U+FEFF)，
 * 这里额外补 U+200B~U+200D（零宽空格 / 零宽非连接符 / 零宽连接符）：从网页或 Word
 * 复制文本时常会带上，`String.trim()` 清不掉，而且完全不可见——界面上看着是「张三」，
 * 存进库里却多了个零宽前缀，会导致精确查询查不到、唯一性判重失效、导出对不上账。
 */
const EDGE_BLANK = /^[\s\u200B-\u200D]+|[\s\u200B-\u200D]+$/g;

/** 去首尾空白，比 String.trim() 多清零宽字符 */
export const trimBlank = (value: string) => value.replace(EDGE_BLANK, '');

/**
 * 递归清洗对象里所有字符串的首尾空白，用于表单提交前统一处理
 *
 * 只递归纯对象与数组；dayjs / Date / File 等实例原样返回，否则会被拆坏。
 */
export function trimDeep<T>(value: T): T {
  if (typeof value === 'string') return trimBlank(value) as T;
  if (Array.isArray(value)) return value.map((item) => trimDeep(item)) as T;
  if (
    value !== null &&
    typeof value === 'object' &&
    Object.getPrototypeOf(value) === Object.prototype
  ) {
    const result: Record<string, unknown> = {};
    for (const [key, item] of Object.entries(value)) {
      result[key] = trimDeep(item);
    }
    return result as T;
  }
  return value;
}
